// Normalize worker rows coming from different APIs (snake_case, camelCase, etc.)
export function normalizeWorker(row = {}, fallbackId) {
  const fullName = row?.FullName || row?.full_name || row?.name || row?.Name || '';

  let first = row?.FirstName || row?.first_name || row?.firstname || row?.Emri || row?.emri || '';
  let last = row?.LastName || row?.last_name || row?.lastname || row?.Mbiemri || row?.mbiemri || '';

  if ((!first || !last) && fullName) {
    const parts = String(fullName).trim().split(/\s+/);
    if (!first && parts.length) first = parts.shift();
    if (!last && parts.length) last = parts.join(' ');
  }

  return {
    ...row,
    Id: row?.Id ?? row?.id ?? row?.ID ?? fallbackId,
    FirstName: first,
    LastName: last,
    Email: row?.Email ?? row?.email,
    // Punëtori ka dy adresa: personalen dhe atë të kompanisë. `preferred_email`
    // vendos se ku i shkojnë njoftimet (migrimi 077). Normalizuesi i hidhte të
    // dyja fushat, ndaj çdo ekran që niste nga ky objekt i shkruante gjithmonë
    // adresës personale — edhe kur HR-ja kishte zgjedhur atë të punës.
    WorkEmail: row?.WorkEmail ?? row?.work_email,
    PreferredEmail: row?.PreferredEmail ?? row?.preferred_email,
    Department: row?.Department ?? row?.department ?? row?.DepartmentName ?? row?.department_name ?? row?.Dept ?? row?.dept,
  };
}

/**
 * Adresa ku i shkruhet punëtorit — e njëjta rregull si te serveri
 * (`backend/services/contactEmail.js`): e zgjedhura e para, tjetra si rezervë,
 * që një njoftim të mos humbasë sepse njëra fushë është bosh.
 */
export function contactEmailOf(worker = {}) {
  const personal = String(worker?.Email ?? worker?.email ?? '').trim();
  const work = String(worker?.WorkEmail ?? worker?.work_email ?? '').trim();
  const pref = worker?.PreferredEmail ?? worker?.preferred_email;
  if (pref === 'work' && work) return work;
  return personal || work || '';
}

export default normalizeWorker;
